import {
  fragmentCalendar,
  fragmentSchedule,
  serializeCalendar,
  serializeWeekSchedule,
} from './serializers';

import {
  gql,
  sendAPIRequest,
  insertGraphQLFragments,
} from './GraphQLClient';


export async function getCalendarByOperatorId(params) {
  const { companyId, operatorId, startDate, endDate } = params || {};
  const variables = {
    companyId,
    operatorId,
    startDate,
    endDate,
  };
  const query = insertGraphQLFragments(gql`
    query ($companyId: Uuid!, $operatorId: ID!, $startDate: Date!, $endDate: Date!) {
      workCalendarByEmployee(companyId: $companyId, employeeId: $operatorId, startDate: $startDate, endDate: $endDate) {
        ...fragmentCalendar
      }
    }
  `, { fragmentCalendar });
  return sendAPIRequest(query, variables).then(entries => entries.map(serializeCalendar));
}


export async function getCalendarHeatmap(params) {
  const { companyId, startDate, endDate } = params || {};
  const variables = {
    companyId,
    startDate,
    endDate,
  };
  const query = insertGraphQLFragments(gql`
    query ($companyId: Uuid!, $startDate: Date!, $endDate: Date!) {
      workCalendarHeatMap(companyId: $companyId, startDate: $startDate, endDate: $endDate) {
        ...fragmentCalendar
      }
    }
  `, { fragmentCalendar });
  return sendAPIRequest(query, variables).then(entries => entries.map(serializeCalendar));
}


export async function getWeekSchedule(companyId, operatorId) {
  const query = insertGraphQLFragments(gql`
    query ($companyId: Uuid!, $operatorId: ID!) {
      schedule(companyId: $companyId, employeeId: $operatorId) {
        ...fragmentShedule
      }
    }
  `, { fragmentSchedule });
  return sendAPIRequest(query, { companyId, operatorId }).then(serializeWeekSchedule);
}


export async function getScheduleTimeOffPeriods(companyId, operatorId) {
  const query = gql`
    query ($companyId: Uuid!, $operatorId: ID!) {
      scheduleExceptions(companyId: $companyId, employeeId: $operatorId, forFuture: true) {
        id
        startDate
        endDate
      }
    }
  `;
  return sendAPIRequest(query, { companyId, operatorId });
}


export async function saveWeekSchedule(companyId, operatorId, schedule, maxOpenCases ) {
  const query = insertGraphQLFragments(gql`
    mutation ($companyId: Uuid!, $operatorId: ID!, $schedule: InputSchedule!, $maxOpenCases: Int!) {
      editSchedule(companyId: $companyId, employeeId: $operatorId, schedule: $schedule, maxOpenCases: $maxOpenCases) {
        ...fragmentShedule
      }
    }
  `, { fragmentSchedule });
  const variables = {
    companyId,
    operatorId,
    schedule,
    maxOpenCases,
  };
  return sendAPIRequest(query, variables).then(serializeWeekSchedule);
}


export async function addScheduleTimeOff(companyId, operatorId, startDate, endDate) {
  const query = gql`
    mutation ($companyId: Uuid!, $operatorId: ID!, $startDate: Date!, $endDate: Date!) {
      addScheduleException(companyId: $companyId, employeeId: $operatorId, startDate: $startDate, endDate: $endDate) {
        id
        startDate
        endDate
      }
    }
  `;
  const variables = {
    companyId,
    operatorId,
    startDate,
    endDate,
  };
  return sendAPIRequest(query, variables);
}


export async function removeScheduleTimeOff(companyId, timeOffId) {
  const query = gql`
    mutation ($companyId: Uuid!, $timeOffId: Uuid!) {
      deleteScheduleException(companyId: $companyId, exceptionId: $timeOffId) {
        id
      }
    }
  `;
  return sendAPIRequest(query, { companyId, timeOffId });
}

export async function getMaxOpenCases(companyId, operatorId) {
  const query = gql`
    query ($companyId: Uuid!, $operatorId: ID!) {
      maxOpenCases(companyId: $companyId, employeeId: $operatorId)
    }
  `;
  return sendAPIRequest(query, { companyId, operatorId });
}
